import React from 'react';
import useCurrentTextStyle from '@src/hooks/useCurrentTextStyle';

export const ArticleExcerpt = ({ article, settings, }) => {
  const { getCurrentTextStyle } = useCurrentTextStyle();

  const {
    colour_scheme,
    classes,
    excerpt_style,
    excerpt_style_mobile,
    excerpt_style_tablet,
    excerpt_style_ultrawide,
    excerpt_style_enable_responsive,
    excerpt_max_chars = 120,
    excerpt_alignment = 'left',
    padding_top = 0,
    padding_right = 0,
    padding_bottom = 0,
    padding_left = 0,
    margin_top = 0,
    margin_right = 0,
    margin_bottom = 0,
    margin_left = 0
  } = settings;

  // Do somehthing for description instead of excerpt
  if (!article?.excerpt) return null;

  const truncateText = (text: string, maxChars: number): string => {
    // If maxChars is 0, return full text (no limit)
    if (maxChars === 0) return text;
    
    // If text is shorter than limit, return as-is
    if (text.length <= maxChars) return text;
    
    // Truncate and add ellipsis
    // Try to break at a word boundary if possible
    const truncated = text.substring(0, maxChars);
    const lastSpaceIndex = truncated.lastIndexOf(' ');
    
    // If we can break at a word boundary and it's not too far back, use that
    if (lastSpaceIndex > maxChars * 0.8) {
      return truncated.substring(0, lastSpaceIndex) + '...';
    }
    
    // Otherwise, just truncate at the character limit
    return truncated + '...';
  };

  const displayExcerpt = truncateText(article.excerpt, excerpt_max_chars);

  return (
    <div 
      className={`
        w-full
        color-${colour_scheme}
        text-${excerpt_alignment}
        pt-[${padding_top}px]
        pb-[${padding_bottom}px]
        pl-[${padding_left}px]
        pr-[${padding_right}px]
        mt-[${margin_top}px]
        mb-[${margin_bottom}px]
        ml-[${margin_left}px]
        mr-[${margin_right}px]
        ${classes}
      `}      >
        <p className={getCurrentTextStyle(excerpt_style, excerpt_style_enable_responsive, excerpt_style_mobile, excerpt_style_tablet, excerpt_style_ultrawide) || 'b1'}>
          {displayExcerpt}
        </p>
      </div>
  );
};